import { RestorePassword } from "./RestorePassword";
import { VerifyEmail } from "./VerifyEmail";

export const ForgotPassword = ({ isEmailVerify }: { isEmailVerify?: boolean }) => {
  return isEmailVerify ? <RestorePassword /> : <VerifyEmail />;
}